var lsSelectedAlbum = localStorage.getItem('selectedAlbum')
if (!lsSelectedAlbum) {
  lsSelectedAlbum = 0
}

let id_cur = 0;
// initial state
const state = {
  selectedAlbum: lsSelectedAlbum,
  album_array: [
    {
      id: id_cur++,
      title: 'Stolen Beats',
      subtitle: 'Made. Stolen. Released.',
      release_date: '2022',
      publisher: 'Raging Family',
      description: 'Beats from Eden, taken from his home.',
      coverSrc: 'static/album_art/stolen_beats.jpg',
      track_root: 'stolen_beats',
      tracks: [

        { id: 0, name: 'One', file_name: 'one.mp3', artist: 'Raging Family' },
        { id: 1, name: 'Two', file_name: 'two.mp3', artist: 'Raging Family' },
        { id: 2, name: 'Three', file_name: 'three.mp3', artist: 'Raging Family' },
        { id: 3, name: 'Four', file_name: 'four.mp3', artist: 'Raging Family' },
        { id: 4, name: 'Five', file_name: 'five.mp3', artist: 'Raging Family' },
        { id: 5, name: 'Six', file_name: 'six.mp3', artist: 'Raging Family' },
        { id: 6, name: 'Sever', file_name: 'seven.mp3', artist: 'Raging Family' },
        { id: 7, name: 'Eight', file_name: 'eight.mp3', artist: 'Raging Family' },
        { id: 8, name: 'Nine', file_name: 'nine.mp3', artist: 'Raging Family' },
        { id: 9, name: 'Ten', file_name: 'ten.mp3', artist: 'Raging Family' }
      ]
    },
    {
      id: id_cur++,
      title: 'UFO',
      subtitle: '3 Unknown Aliens.',
      release_date: '2025',
      publisher: 'Raging Family',
      description: '3 Unknown Aliens make sounds.',
      coverSrc: 'static/album_art/ufo.jpg',
      track_root: 'ufo',
      tracks: [
        { id: 0, name: 'Intro', file_name: '2019-02-24-intro.mp3', artist: 'Raging Family' },
        { id: 1, name: 'Baby Baby', file_name: '2019-03-01-baby-baby.mp3', artist: 'Raging Family' },
        { id: 2, name: 'Jam 01', file_name: '2019-03-20-jam01.mp3', artist: 'Raging Family' },
        { id: 3, name: 'Jam 02', file_name: '2019-03-20-jam02.mp3', artist: 'Raging Family' },
        { id: 4, name: 'FourTet', file_name: 'fourtet.ooog', artist: 'Raging Family' }
      ]
    },
    {
      id: id_cur++,
      title: 'Golden Age Conservatory',
      subtitle: 'A Tribute to the Classical Masterminds.',
      release_date: '2010',
      publisher: 'Raging Family',
      description: 'A Tribute to the Classical Masterminds.',
      coverSrc: 'static/album_art/golden_age_conservatory.jpg',
      track_root: 'golden_age_conservatory',
      tracks: [
        { id: 0, name: 'Sham Bach', file_name: 'Sham Bach.mp3', artist: 'Eden' },
        { id: 1, name: 'Allegro Barbaro Bartok', file_name: 'Allegro Barbaro Bartok.mp3', artist: 'Eden' },
        { id: 2, name: 'Delgado Beethoven', file_name: 'Delgado Beethoven.mp3', artist: 'Eden' },
        { id: 3, name: 'Moonlight Sonata Beethoven', file_name: 'Moonlight Sonata Beethoven.mp3', artist: 'Eden' },
        { id: 4, name: 'Rolling Winds Bartok', file_name: 'Rolling Winds Bartok.mp3', artist: 'Eden' },
        { id: 5, name: 'Rain Prelude Chopen', file_name: 'Rain Prelude Chopen.mp3', artist: 'Eden' },
        { id: 6, name: 'Prelude to a Beat Bach', file_name: 'Prelude to a Beat Bach.mp3', artist: 'Eden' },
        { id: 7, name: 'Soffegiti', file_name: 'Soffegiti.mp3', artist: 'Eden' },
        { id: 8, name: 'Shake Nar', file_name: 'Shake Nar.mp3', artist: 'Eden' },
        { id: 9, name: 'Sonatina in G Beethoven', file_name: 'Sonatina in G Beethoven.mp3', artist: 'Eden' },
        { id: 10, name: 'Adalgi', file_name: 'Adalgi.mp3', artist: 'Eden' },
        { id: 11, name: 'Remis Beethoven', file_name: 'Remis Beethoven.mp3', artist: 'Eden' },
        { id: 12, name: 'Baga Beethoven', file_name: 'Baga Beethoven.mp3', artist: 'Eden' },
        { id: 13, name: 'Crescendo Chopen', file_name: 'Crescendo Chopen.mp3', artist: 'Eden' }
      ]
    },
    {
      id: id_cur++,
      title: 'Bomb Bay Doors',
      subtitle: 'Re-edits and Mashups from DJ Free.',
      release_date: '2008',
      publisher: 'Not for Sale',
      description: 'MASHUPS AND RE-EDITS BY DJ FREE, FEATURING LUDA. GHOSTFACE, 50 CENT, SNOOP DOG, WU TANG, OUTKAST, NAS, KELIS, WEEZY, AND MORE...',
      coverSrc: 'static/album_art/bomb_bay_doors.jpg',
      track_root: 'bomb_bay_doors',
      tracks: [
        { id: 0, name: 'Track 01', file_name: '01 Track 01.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 02', file_name: '02 Track 02.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 03', file_name: '03 Track 03.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 04', file_name: '04 Track 04.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 05', file_name: '05 Track 05.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 06', file_name: '06 Track 06.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 07', file_name: '07 Track 07.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 08', file_name: '08 Track 08.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 09', file_name: '09 Track 09.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 10', file_name: '10 Track 10.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 11', file_name: '11 Track 11.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 12', file_name: '12 Track 12.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 13', file_name: '13 Track 13.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 14', file_name: '14 Track 14.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 15', file_name: '15 Track 15.mp3', artist: 'DJ Free' },
        { id: 1, name: 'Track 16', file_name: '16 Track 16.mp3', artist: 'DJ Free' }
      ]
    },
    {
      id: id_cur++,
      title: 'Space Tragedy',
      subtitle: 'An epic saga set in the sixth dimension of outer space.',
      release_date: '2007',
      publisher: 'Raging Family',
      description: `"An epic saga set in the sixth dimension of outer space"<br> "The official sequel to Black Holes, Crumpet Land at it's best" <br> "Raging Family©, but a man from the future sent a capsule in mp3 format to download" <br> - Space Man`,
      coverSrc: 'static/album_art/space_tragedy.jpg',
      track_root: 'space_tragedy',
      tracks: [
        { id: 0, name: 'Everything is You', file_name: '01 Everything is You.mp3', artist: 'Raging Family' },
        { id: 1, name: 'Out of Reach', file_name: '02 Out of Reach.mp3', artist: 'Raging Family' },
        { id: 2, name: 'Outside the Window', file_name: '03 Outside the Window.mp3', artist: 'Raging Family' },
        { id: 3, name: 'The Colors in Your Eyes', file_name: '04 The Colors in Your Eyes.mp3', artist: 'Raging Family' },
        { id: 4, name: 'Dark Side of Nuptar', file_name: '05 Dark Side of Nuptar.mp3', artist: 'Raging Family' },
        { id: 5, name: 'Floating in an Airtight Vacuum', file_name: '07 Floating in an Airtight Vacuum 1.mp3', artist: 'Raging Family' },
        { id: 6, name: 'Secret Owl', file_name: '09 Secret Owl.mp3', artist: 'Raging Family' },
        { id: 7, name: 'Life is Full of Art', file_name: '10 Life is Full of Art 2.mp3', artist: 'Raging Family' },
        { id: 8, name: 'Bottom of a Black Hole', file_name: '11 Bottom of a Black Hole.mp3', artist: 'Raging Family' },
        { id: 9, name: 'Cryogenically Frozen', file_name: '12 Cryogenically Frozen.mp3', artist: 'Raging Family' },
        { id: 10, name: 'Brawn of the Planets', file_name: '13 Brawn of the Planets.mp3', artist: 'Raging Family' },
        { id: 11, name: 'Smooth Landing', file_name: '14 Smooth Landing.mp3', artist: 'Raging Family' },
        { id: 12, name: 'Satellite Feathers', file_name: '15 Satellite Feathers.mp3', artist: 'Raging Family' }
      ]
    },
    {
      id: id_cur++,
      title: 'Highs and Lows',
      subtitle: '"A touch of RJD2 with the feeling that I always overestimated in Mos Def." - Music is Not Dead',
      release_date: '2007',
      publisher: 'Raging Family',
      description: `"Highs and Lows might be one of the best albums of 2006. There haven't been many CDs this year that I have played repeatedly and played often. In fact, I can count them on my hand. However, there is something about Highs and Lows that is making this stand out a little further. Oregon MC Marv Ellis and Cosmos Corbin's Highs and Lows proves that psychedelic hip-hop can be done. Its almost like a drug trip of sorts and the best legal high you can get right now."<br /><b>- The Couch Sessions</b><br /><br />"Marv Ellis and Cosmos are backing their cerebral rhymes with some of the best beats to grace these ears in months. It's pen and paper hip hop, surviving while the ego battles the Id. Their partnership with ragingfamily.com offers their fruits, an honest surprise in the quality of a downloadable MP3 album. A touch of RJD2 with the feeling that I always overestimated in Mos Def. The way Cosmos blends the organic/ ethnic with the future is worth the time. When an album not only creates conversation, but entertainment, you have to give it it's due."<br><b>- Music is Not Dead</b>`,
      coverSrc: 'static/album_art/highs_and_lows.jpg',
      track_root: 'highs_and_lows',
      tracks: [
        { id: 0, name: 'When it Hits', file_name: '01 When it Hits.mp3', artist: 'Marv Ellis and Cosmos' },
        { id: 1, name: 'She Needs Too', file_name: '02 She Needs Too.mp3', artist: 'Marv Ellis and Cosmos' },
        { id: 2, name: 'One On My List', file_name: '03 One On My List.mp3', artist: 'Marv Ellis and Cosmos' },
        { id: 3, name: 'Understand Im Nice', file_name: '04 Understand Im Nice.mp3', artist: 'Marv Ellis and Cosmos' },
        { id: 4, name: 'Electropimp', file_name: '05 Electropimp.mp3', artist: 'Marv Ellis and Cosmos' },
        { id: 5, name: 'Slide Off My Back', file_name: '06 Slide Off My Back.mp3', artist: 'Marv Ellis and Cosmos' },
        { id: 6, name: 'Lazy Sunday', file_name: '07 Lazy Sunday.mp3', artist: 'Marv Ellis and Cosmos' },
        { id: 7, name: 'Until Then', file_name: '08 Until Then.mp3', artist: 'Marv Ellis and Cosmos' }
      ]
    },
    {
      id: id_cur++,
      title: 'The Program is You',
      subtitle: 'Electro IDM from DJ Free and Joey of Unckle Nancy, dense ultra glitch crooning.',
      release_date: '2006',
      publisher: 'Raging Family',
      description: `Who is Legomaker? Legomaker began when DJ Free of the Raging Family (DMC turntablist, and NW hip hop producer) began cutting and chopping beats into tiny lego like bricks. Soon Joey (A.K.A. Unckle Nancy) heard the music and lent his crooning Robert Smith meets Faith no More vocal style to the mix. Soon after Tiphany Lynn Hohmann and Cosmos Corbin (pictured below) of the Raging Family joined the group.`,
      coverSrc: 'static/album_art/the_program_is_you.jpg',
      track_root: 'the_program_is_you',
      tracks: [
        { id: 0, name: 'the open and shut', file_name: '01 the open and shut.mp3', artist: 'Lego Maker' },
        { id: 1, name: 'are you', file_name: '02 are you.mp3', artist: 'Lego Maker' },
        { id: 2, name: 'i really shouldnt', file_name: '03 i really shouldnt.mp3', artist: 'Lego Maker' },
        { id: 3, name: 'hello little mine', file_name: '04 hello little mine.mp3', artist: 'Lego Maker' },
        { id: 4, name: 'a better man', file_name: '05 a better man.mp3', artist: 'Lego Maker' },
        { id: 5, name: 'fade away', file_name: '06 fade away.mp3', artist: 'Lego Maker' },
        { id: 6, name: 'the name', file_name: '07 the name.mp3', artist: 'Lego Maker' },
        { id: 7, name: 'my demise', file_name: '08 my demise.mp3', artist: 'Lego Maker' },
        { id: 8, name: 'expecialy you', file_name: '09 expecialy you.mp3', artist: 'Lego Maker' },
        { id: 9, name: 'are you listening', file_name: '10 are you listening.mp3', artist: 'Lego Maker' },
        { id: 10, name: 'the eraser (dj free vs. mood area 52)', file_name: '11 the eraser (dj free vs. mood area 52).mp3', artist: 'Lego Maker' }
      ]
    },
    {
      id: id_cur++,
      title: 'Black Holes',
      subtitle: '"the electro-clash abandon of Meat Beat Manifesto, the jazz exploration of Miles Davis and Sun Ra Arkestra" - 3hive.com',
      release_date: '2005',
      publisher: 'Raging Family',
      description: `What is the most thuggin entity in the Universe? Modern science has proved without a doubt that Super Massive Black Holes are uncontested as the most thuggin entities in the universe.`,
      coverSrc: 'static/album_art/black_holes.jpg',
      track_root: 'black_holes',
      tracks: [
        { id: 0, name: 'The Orkastring Bowsting', file_name: '01 The Orkastring Bowsting.mp3', artist: 'Raging Family' },
        { id: 1, name: 'The Next Stop is Extended', file_name: '02 The Next Stop is Extended.mp3', artist: 'Raging Family' },
        { id: 2, name: 'The Klep Telescope', file_name: '03 The Klep Telescope.mp3', artist: 'Raging Family' },
        { id: 3, name: 'Head Like a Balloon', file_name: '04 Head Like a Balloon.mp3', artist: 'Raging Family' },
        { id: 4, name: 'The Formation of the Galaxy', file_name: '05 The Formation of the Galaxy.mp3', artist: 'Raging Family' },
        { id: 5, name: 'Disrupted Transmission', file_name: '06 Disrupted Transmission.mp3', artist: 'Raging Family' },
        { id: 6, name: 'Latent Destructive Power', file_name: '07 Latent Destructive Power.mp3', artist: 'Raging Family' },
        { id: 7, name: 'The Exploding Symphony of Madness', file_name: '08 The Exploding Symphony of Madness.mp3', artist: 'Raging Family' },
        { id: 8, name: 'Summer Kisses', file_name: '09 Summer Kisses.mp3', artist: 'Raging Family' },
        { id: 9, name: 'Pond Dub', file_name: '10 Pond Dub.mp3', artist: 'Raging Family' },
        { id: 10, name: 'Dramatic Acceleration', file_name: '11 Dramatic Acceleration.mp3', artist: 'Raging Family' },
        { id: 11, name: 'The Supermassive Black Hole', file_name: '12 The Supermassive Black Hole.mp3', artist: 'Raging Family' },
        { id: 12, name: 'Requiem556', file_name: '13 Requiem556.mp3', artist: 'Raging Family' }
      ]
    },
    {
      id: id_cur++,
      title: 'Talk Sick Buffet',
      subtitle: '“Sounds like Massive Attack or Rae and Christian at their best. Get this.” - Groove Distribution',
      release_date: '2005',
      publisher: 'Raging Family',
      description: `This album was served by Raging Family in the wee hours of the late night. Working with their friends and fellow Eugene Mc's This album was created while having a great time using a collection of dj Free's most reserved sampladelic relic relish beats.<br><br> "One of the years most fucked up Hip Hop albums, truley a work by some of our times most insane youth." -Music Headspin 2005<br><br> "Working on this project made my Noodle go Oozicle" -dj Free 2005<br><br>"Talk Sick Buffet turned out to be a feast of the most delectible cheeses and fruity wines ever experienced in the third dimension." - Cosmos 2005 `,
      coverSrc: 'static/album_art/talk_sick_buffet.jpg',
      track_root: 'talk_sick_buffet',
      tracks: [
        { id: 0, name: 'Appatizer', file_name: '01 Appatizer.mp3', artist: 'Raging Family, dj Free and Metric' },
        { id: 1, name: 'Freedom', file_name: '02 Freedom.mp3', artist: 'Raging Family, Metric' },
        { id: 2, name: 'The Ill Track', file_name: '03 The Ill Track.mp3', artist: 'Raging Family' },
        { id: 3, name: 'AA Interlude', file_name: '04 AA Interlude.mp3', artist: 'Raging Family' },
        { id: 4, name: 'Eliazars Bizar', file_name: '05 Eliazars Bizar.mp3', artist: `Raging Family, Eli'azar and dj Free` },
        { id: 5, name: 'Storys Been Told', file_name: '06 Storys Been Told.mp3', artist: 'Raging Family, Manifesto' },
        { id: 6, name: 'Emerald City', file_name: '07 Emerald City.mp3', artist: 'Raging Family, Destiny' },
        { id: 7, name: 'Coin Sides', file_name: '08 Coin Sides.mp3', artist: 'Raging Family, dj Free and Metric ' },
        { id: 8, name: 'Epistimology 2', file_name: '09 Epistimology 2.mp3', artist: 'Raging Family, Banana Fro and dj Free' },
        { id: 9, name: 'Me Myself and I', file_name: '10 Me Myself and I.mp3', artist: 'Raging Family, Marv Elis and dj Free' },
        { id: 10, name: 'Make Love to This Poem', file_name: '11 Make Love to This Poem.mp3', artist: 'Raging Family, Hunter' },
        { id: 11, name: 'La Cancion del Banjo', file_name: '12 La Cancion del Banjo.mp3', artist: 'Raging Family, dj Free ala mode' },
        { id: 12, name: 'Super Friday Night', file_name: '14 Super Friday Night.mp3', artist: 'Raging Family, Juice to make it happen' },
        { id: 13, name: 'IML Theme', file_name: '15 IML Theme.mp3', artist: 'Raging Family, International Men of Leisure' },
        { id: 14, name: 'Epistimology 2 Remix', file_name: '16 Epistimology 2 Remix.mp3', artist: 'Raging Family,  dj Free and Banana Fro' }
      ]
    },
    {
      id: id_cur++,
      title: 'Everywhere is Zoom',
      subtitle: 'Experimental glitch lounge album.',
      release_date: '2003',
      publisher: 'Raging Family',
      description: `If zoom were only somewhere it would then be everywhere.`,
      coverSrc: 'static/album_art/everywhere_is_zoom.jpg',
      track_root: 'everywhere_is_zoom',
      tracks: [
        { id: 0, name: 'Landing In the Bay', file_name: '01_LandingInTheBay.mp3', artist: 'Raging Family' },
        { id: 1, name: 'Adjusting to Plan', file_name: '02_AdjustingToPlan.mp3', artist: 'Raging Family' },
        { id: 2, name: 'Falling in Love', file_name: '03_FallingInLove.mp3', artist: 'Raging Family' },
        { id: 3, name: 'The King of Swing', file_name: '04_TheKingofSwing.mp3', artist: 'Raging Family' },
        { id: 4, name: 'Homesick for Worm', file_name: '05_HomesickForWorm.mp3', artist: 'Raging Family' },
        { id: 5, name: 'Zig Zag Noises', file_name: '06_ZigZagNoises.mp3', artist: 'Raging Family' },
        { id: 6, name: 'Hotel Motel', file_name: '07_HotelMotel.mp3', artist: 'Raging Family' },
        { id: 7, name: 'The Long Drive To', file_name: '08_TheLongDriveTo.mp3', artist: 'Raging Family' },
        { id: 8, name: 'The Sounds of Silence', file_name: '09_TheSoundsofSilence.mp3', artist: 'Raging Family' },
        { id: 9, name: 'The Segundo Showdown', file_name: '10_TheSegundoShowdown.mp3', artist: 'Raging Family' },
        { id: 10, name: 'The Impossible Hi', file_name: '11_TheImpossibleHi.mp3', artist: 'Raging Family' },
        { id: 11, name: 'Boarding the Hype', file_name: '12_BoardingTheHype.mp3', artist: 'Raging Family' },
        { id: 12, name: 'The Spider Web Co', file_name: '13_TheSpiderWebCo.mp3', artist: 'Raging Family' }
      ]
    },
    {
      id: id_cur++,
      title: 'Longhorn Pete',
      subtitle: 'DJ set, original tracks and remixes.',
      release_date: '2003',
      publisher: 'Raging Family',
      description: `Thrill to the sound of the international men of leisure's live set...<br><br>Performed with respect to the infamous Longhorn Pete and his memory from Oregon to the Netherlands...`,
      coverSrc: 'static/album_art/longhorn_pete.jpg',
      track_root: 'longhorn_pete',
      tracks: [
        { id: 0, name: 'Sounds So Perfect', file_name: '01_SoundsSoPerfect.mp3', artist: 'Raging Family' },
        { id: 1, name: 'Bass Line For All', file_name: '02_BassLineForAll.mp3', artist: 'Raging Family' },
        { id: 2, name: 'Scottish Highlands', file_name: '03_ScottishHighlands.mp3', artist: 'Raging Family' },
        { id: 3, name: 'Porno Flic Bitches', file_name: '04_PornoFlicBitches.mp3', artist: 'Raging Family' },
        { id: 4, name: 'Longhorn Pete', file_name: '05_LonghornPete.mp3', artist: 'Raging Family' },
        { id: 5, name: 'Miami Beach', file_name: '06_MiamiBeach.mp3', artist: 'Raging Family' },
        { id: 6, name: 'Ants In Your Pants', file_name: '07_AntsInYourPants.mp3', artist: 'Raging Family' },
        { id: 7, name: 'Raw Twin Handrockin', file_name: '08_RawTwinHandrockin.mp3', artist: 'Raging Family' },
        { id: 8, name: 'What Did You Say', file_name: '09_WhatDidYouSay.mp3', artist: 'Raging Family' },
        { id: 9, name: 'Get Up Clap Your Hands', file_name: '10_GetUpClapYourHands.mp3', artist: 'Raging Family' },
        { id: 10, name: 'Do You Want To Be', file_name: '12_DoYouWantToBe.mp3', artist: 'Raging Family' },
        { id: 11, name: `You'll Love Me Again`, file_name: '13_YoullLoveMeAgain.mp3', artist: 'Raging Family' },
        { id: 12, name: 'Mobsters In Havana', file_name: '14_MobstersInHavana.mp3', artist: 'Raging Family' },
        { id: 13, name: 'Mr Hollands Opus', file_name: '15_MrHollandsOpus.mp3', artist: 'Raging Family' },
        { id: 14, name: 'Welcome To My Bungle', file_name: '16_WelcomeToMyBungle.mp3', artist: 'Raging Family' }
      ]
    },
    {
      id: id_cur++,
      title: 'Speed of Life',
      subtitle: '“Sounds like Massive Attack or Rae and Christian at their best. Get this.” - Groove Distribution',
      release_date: '2002',
      publisher: 'Raging Family',
      description: `“Straight out of Eugene OR, if you can believe comes this excellent debut downtempo CD from the Raging Family. Truly one of the nicest jazzy downtempo records in recent memory. Warm soulful vocals over smooth grooves that skip and slide along hip hop beats and broken shards of rhythm. Sounds like Massive Attack or Rae and Christian at their best. Get this.” - Review of Speed of Life, from Groove Distribution <br><br> The CD features guest performances from Emma Powell, Erika Guthrie, and Brooks Barnett.`,
      coverSrc: 'static/album_art/speed_of_life.jpg',
      track_root: 'speed_of_life',
      tracks: [
        { id: 0, name: 'Wavedrops', file_name: '01_Wavedrops.mp3', artist: 'Raging Family' },
        { id: 1, name: 'Impossible', file_name: '02_Impossible.mp3', artist: 'Raging Family' },
        { id: 2, name: 'Eat My Fruit', file_name: '03_EatMyFruit.mp3', artist: 'Raging Family' },
        { id: 3, name: 'Lions Shadow', file_name: '04_LionsShadow.mp3', artist: 'Raging Family' },
        { id: 4, name: 'Blunts To Roll', file_name: '05_BluntsToRoll.mp3', artist: 'Raging Family' },
        { id: 5, name: 'Expose', file_name: '06_Expose.mp3', artist: 'Raging Family' },
        { id: 6, name: 'Outsiders', file_name: '07_Outsiders.mp3', artist: 'Raging Family' },
        { id: 7, name: 'Microscope', file_name: '08_Microscope.mp3', artist: 'Raging Family' },
        { id: 8, name: 'Cant See You', file_name: '09_CantSeeYou.mp3', artist: 'Raging Family' },
        { id: 9, name: 'Darkness', file_name: '10_Darkness.mp3', artist: 'Raging Family' },
        { id: 10, name: 'Just Ask', file_name: '11_JustAsk.mp3', artist: 'Raging Family' },
        { id: 11, name: 'Doko Des Ka', file_name: '12_DokoDesKa.mp3', artist: 'Raging Family' },
        { id: 12, name: 'The Ninja', file_name: '13_TheNinja.mp3', artist: 'Raging Family' },
        { id: 13, name: 'Minus Ten', file_name: '14_MinusTen.mp3', artist: 'Raging Family' },
        { id: 14, name: 'Whips', file_name: '15_Whips.mp3', artist: 'Raging Family' }
      ]
    }
  ]
}

// getters
// const getters = {
//   selectedAlbum: (state, getters) => {
//     return getters.cartProducts.reduce((total, product) => {
//       return total + product.price * product.quantity
//     }, 0)
//   }
// }
// actions
const actions = {
  getSelectedAlbum ({ commit }) {
    console.log(state.selectedAlbum)
  },
  changeSelectedAlbum ({ state, commit }, id) {
    commit('setSelectedAlbum', { id: id })
    localStorage.setItem('selectedAlbum', id)
    console.log(state.selectedAlbum)
  }
}

// mutations
const mutations = {
  setSelectedAlbum (state, { id }) {
    state.selectedAlbum = id
  }
}

// getters
const getters = {
  allAlbums: state => state.album_array,
  selectedAlbum: state => state.album_array[state.selectedAlbum]
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/albums.js